export default {
  de: "Deutsch",
  en: "English",
};
